"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PeoplesMap = _interopRequireDefault(require("@rsuite/icon-font/lib/people/PeoplesMap"));

// Generated by script, don't edit it please.
var PeoplesMap = (0, _createSvgIcon["default"])({
  as: _PeoplesMap["default"],
  ariaLabel: 'peoples map',
  category: 'people',
  displayName: 'PeoplesMap'
});
var _default = PeoplesMap;
exports["default"] = _default;
module.exports = exports.default;